import type { MouseEvent } from 'react'

export const OFFER_ID = 'oferta'

/**
 * Lleva al usuario al bloque de precio del final de la página.
 * Respeta prefers-reduced-motion saltando la animación de scroll.
 */
export function scrollToOffer(event?: MouseEvent<HTMLElement>) {
  const target = document.getElementById(OFFER_ID)
  if (!target) return

  event?.preventDefault()

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' })
}
